import {Account, ThemeColors} from './Navigator.type';
import {NavigatorMap} from './Navigator.map';

export class NavigatorService {
  static shouldRenderFilialsSubmenu(account: Account): boolean {
    return account.features?.includes('filials') || false;
  }

  static shouldRenderUsersSubmenu(account: Account): boolean {
    return account.accountType !== 'personal';
  }

  static getFilialsEditUrl(account: Account): string {
    return `/${account.code}/admin/filials/${account.firstFilial?.code}/edit`;
  }

  static getUsersUrl(account: Account): string {
    if (account.accountType === 'personal') {
      return `/${account.code}/admin/alunos`;
    }
    return '#'; // Para contas não-personal, usa submenu
  }

  static getProfileEditUrl(account: Account, userId: string | number): string {
    return `/${account.code}/admin/alunos/${userId}/edit`;
  }

  static getLogoutUrl(): string {
    return '/users/sign_out';
  }

  static hasSubmenu(featureName: string): boolean {
    const schema = NavigatorMap.getFeatureSchema();
    return schema[featureName]?.items?.length > 0;
  }

  static getFeatureLabel(featureName: string): string {
    const schema = NavigatorMap.getFeatureSchema();
    return schema[featureName]?.label || '';
  }

  static getFeatureIcon(featureName: string): string {
    const schema = NavigatorMap.getFeatureSchema();
    return schema[featureName]?.icon || '';
  }

  static isValidFeature(featureName: string): boolean {
    const schema = NavigatorMap.getFeatureSchema();
    return !!schema[featureName];
  }

  static isSpecialFeature(featureName: string): boolean {
    return ['filials', 'users'].includes(featureName);
  }

  static validateNavigatorProps(account: Account, user: any): boolean {
    if (!account || !user) {
      console.error('Navigator: account and user are required props');
      return false;
    }

    if (!account.code) {
      console.error('Navigator: account.code is required');
      return false;
    }


    return true;
  }

  static hasTheme(account: Account): boolean {
    return !!account.app?.account_app_theme?.chosen_settings;
  }
}
